export default __webpack_public_path__ + "static/media/Webinar_Venkatesh.8565365a.jpg";